export const BASEROW_FORMULA_MODES = ['raw', 'simple', 'advanced']
